<template>
  <div id="app">
    <!-- <transition
      mode="out-in"
      :enter-active-class="enteranimate"
      :leave-active-class="leaveanimate"
      appear
    > -->
      <router-view :key="$route.path" />
    <!-- </transition> -->
  </div>
</template>

<script>
  import cardlistdata from '@/assets/js/data/cardlistdata'
  export default {
    components: {
    },
    data(){
      return{
        cardlistdata,
        flag: false,
      }
    },
    mounted(){
      console.log  = function(){}
      if(Object.keys(this.$route.params).length!=0){
        this.cardlistdata.forEach(element => {
            element['cardinfo'].forEach(cell => {
                if(cell["site_name"]==this.$store.state.currentwisher){
                    this.flag=true;
                }
            })
        });
        if(!this.flag) this.$router.push({ path: '/equality_1' })
      }
    },
    // computed:{
    //   leaveanimate(){
    //     return "animated bounceOutLeft";
    //   },
    //   enteranimate(){
    //     return "animated bounceInRight";
    //   },
    // },
  }
</script>

<style>
  #app{
    background-color: #FAFAFA;
  }
</style>
